
export const Amiral_role= "Amiral_role";
	
export const Admin_Role= "Admin_Role";

export const Customer_Role= "Customer_Role";

export const Catalog_Access= "Catalog_Access";

export const OrderList_Access= "OrderList_Access";

export const BackOrder_Access="BackOrder_Access";

export const InvoicesList_Access= "InvoicesList_Access";

export const BackOrder_Cancel= "BackOrder_Cancel";

export const Sales_Statistics_Access= "Sales_Statistics_Access";

export const Customer_Histories_Access= "Customer_Histories_Access";

export const Synchronization_Reports_Access= "Synchronization_Reports_Access";

export const Customer_User_Management= "Customer_User_Management";

export const Supplier_User_Management="Supplier_User_Management";

export const Advertising_Banners_Management="Advertising_Banners_Management";

export const Announcements_Management= "Announcements_Management";

export const Sales_Representatives_Customers_Management= "Sales_Representatives_Customers_Management";

export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboard.text',
        icon: 'fas fa-home',
        link:'/',
        privileges:[]
    },
    {
        id: 6,
        label: 'menuitems.newOrder.text',
        icon: 'fas fa-cart-plus ',
        link:'/orders/newOrder',
        privileges:[Amiral_role,Admin_Role,Customer_Role,Catalog_Access] 
    },
    {
        id: 25,
        label: 'menuitems.orders.text',
        icon: 'fas fa-dolly',
        link:'/orders/list',
        privileges:[Amiral_role,Admin_Role,Customer_Role,OrderList_Access,BackOrder_Access,InvoicesList_Access] 
    },
    {
        id: 70,
        label: 'menuitems.reporting.text',
        icon: 'fas fa-chart-line',
        link:'/reporting',
        privileges:[Amiral_role,Admin_Role,Customer_Role,Sales_Statistics_Access,Customer_Histories_Access,Synchronization_Reports_Access] 
    },
    {
        id: 97,
        label: 'menuitems.subscription.text',
        icon: 'fas fa-users',
        link:'/listOfUsers',
        privileges:[Amiral_role,Admin_Role,Customer_User_Management,Supplier_User_Management,Sales_Representatives_Customers_Management]

    },
    {
        id: 89,
        label: 'menuitems.parameters.text',
        icon: 'fas fa-cogs',
        link:'/parameters',
        privileges:[Amiral_role,Admin_Role,Announcements_Management,Advertising_Banners_Management]

    }
];

